type PasswordToggleElements = {
  button: HTMLButtonElement
  input: HTMLInputElement
  eyeHide: HTMLElement
  eyeShow: HTMLElement
}

function showLabelFor(button: HTMLButtonElement) {
  return button.dataset.showLabel || button.getAttribute("aria-label") || "Show password"
}

function hideLabelFor(button: HTMLButtonElement) {
  return button.dataset.hideLabel || "Hide password"
}

function applyPasswordToggleState(els: PasswordToggleElements, revealed: boolean) {
  const { button, input, eyeHide, eyeShow } = els

  input.type = revealed ? "text" : "password"
  eyeHide.classList.toggle("hidden", revealed)
  eyeShow.classList.toggle("hidden", !revealed)
  button.setAttribute("aria-label", revealed ? hideLabelFor(button) : showLabelFor(button))
}

function getPasswordToggleElements(root: ParentNode): PasswordToggleElements | null {
  const button = root.querySelector<HTMLButtonElement>(".js-password-toggle")
  const input = root.querySelector<HTMLInputElement>("input.js-password-input")
  const eyeHide = root.querySelector<HTMLElement>(".js-eye-hide")
  const eyeShow = root.querySelector<HTMLElement>(".js-eye-show")

  if (!button || !input || !eyeHide || !eyeShow) return null

  return { button, input, eyeHide, eyeShow }
}

export function bindPasswordToggle(root: ParentNode) {
  const els = getPasswordToggleElements(root)
  if (!els) return

  const { button } = els
  if (!button.dataset.showLabel) {
    button.dataset.showLabel = button.getAttribute("aria-label") || "Show password"
  }

  button.addEventListener("click", () => {
    applyPasswordToggleState(els, els.input.type === "password")
  })
}

export function resetPasswordToggle(root: ParentNode) {
  const els = getPasswordToggleElements(root)
  if (!els) return

  applyPasswordToggleState(els, false)
}
